import { PayloadAction, createSlice } from "@reduxjs/toolkit";

const initialState: { unViewedNotifications: number } = {
  unViewedNotifications: 0,
};

export const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    updateUnViewedNotification: (state, action: PayloadAction<number>) => {
      state.unViewedNotifications = action.payload;
    },
  },
});

export const { updateUnViewedNotification } = notificationSlice.actions;

export default notificationSlice.reducer;
